import customFetch from '../../utils/customFetch'
import { API_ENDPOINT } from '../../config'
import {
  RentIndexApiResponseDto,
  RentIndexRequestDto,
  RentIndexResponseDto,
  RentIndexResultDto,
} from '../../@types/rent-index-types'
import { getDefaultLogger } from '../../services/logger/logger'

const toRentIndexResponseDto = ({ min, avg, max }: RentIndexApiResponseDto): RentIndexResponseDto => ({
  minValue: min,
  averageValue: avg,
  maxValue: max,
})

export const postRentIndex = async (rentIndexRequest: RentIndexRequestDto): Promise<RentIndexResultDto | undefined> => {
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include' as const,
    body: JSON.stringify(rentIndexRequest),
  }

  const response = await customFetch(`${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/index/rent`, options)

  if (response.status === 200) {
    const apiResponse = (await response.json()) as RentIndexApiResponseDto
    return {
      status: 'available',
      rentIndex: toRentIndexResponseDto(apiResponse),
    }
  }

  if (response.status === 404) {
    return {
      status: 'notAvailable',
    }
  }

  if (response.status === 400) {
    return {
      status: 'notAvailable',
    }
  }

  getDefaultLogger().warn('Failed to load rent index from index API', response)
  return {
    status: 'error',
  }
}
